import React, { ChangeEvent } from 'react';
import styles from './FiltersSingle.module.scss';
import Search from '/public/svgs/search.svg';
import { Category } from 'generated-graphql';
import Link from 'next/link';

interface FiltersSingleProps {
  categories: Category[],
  c?: Category,
  search?: string,
  onSearch?: (event: ChangeEvent<HTMLInputElement>) => void,
  isWork?: boolean
}

const FiltersSingle: React.FC<FiltersSingleProps> = ({ categories, c: currentCategory, search, onSearch, isWork }) => {
  return (
    <div className={`col-md-3 ${styles.filters}`}>
      {onSearch &&
        <div className={styles.search}>
          <input
            value={search}
            placeholder="Search"
            className="w-100"
            onChange={(e) => onSearch(e)}
          />
          <Search />
        </div>
      }
      {categories.map((c, idx) =>
        c.children?.nodes.length ? (
          <React.Fragment key={idx + "filter"}>
            <div
              className={`${styles.options} ${c.name ? styles.openedOptions : ''}`}
              key={c.id}
              style={{ zIndex: idx }}
            >
              <div
                className={styles.filter}
              >
                <strong> {c.name}</strong>
              </div>
              {c.children?.nodes.length ? (
                <ul>
                  {c.children?.nodes.map((subc: Category) => {
                    if (isWork && subc.slug === 'agent3-group') {
                      return;
                    }

                    const isSelected = currentCategory && currentCategory.id === subc.id;
                    return (
                      <li
                        className={`${isSelected ?
                          styles.selectedItem
                          : ''}`}
                        key={subc.id}
                      >
                        {isSelected ?
                          <><span>{subc.name}</span><div> <Link href={`/resources`} as={`/resources`}>✕</Link></div></> :
                          <Link href={`/resources/c/[...slug]`} as={`/resources/c/${subc.slug}`}>{subc.name}</Link>}

                      </li>
                    )
                  })}
                </ul>
              ) : null}
            </div></React.Fragment>
        ) : null,
      )}
    </div>
  )

}
export default FiltersSingle;